import React from 'react';
import Row from '@/src/components/Layouts/Row/Row';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Input from '@/src/components/Antd/Input/Input';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const AddCode = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    setModal,
    onSubmit,
    firstMaxLength = 50,
    secondMaxLength = 50,
    currentCodes = [],
    disabled,
  } = props;
  const [code, setCode] = React.useState('');
  const [title, setTitle] = React.useState('');
  const [codeErr, setcCodeErr] = React.useState(false);
  const [titleErr, setTitleErr] = React.useState(false);
  const onTitleChange = (e) => {
    setTitle(e);
    if (titleErr) setTitleErr(false);
  };
  const onCodeChange = (e) => {
    setCode(e);
    if (codeErr) setcCodeErr(false);
  };
  const onCancel = () => {
    if (setModal) setModal(false);
  };
  const onOk = () => {
    if (!title) {
      setTitleErr(true);
      return;
    }
    if (!code) {
      setcCodeErr(true);
      return;
    }
    if (currentCodes.find((i) => i.title === title)) {
      setTitleErr(true);
      return;
    }
    if (onSubmit) onSubmit({ code, title });
    if (setModal) setModal(false);
  };
  return (
    <React.Fragment>
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <TopContainer>
                  <ItemWrapper
                    title={getI18n(
                      'allProducts.addproductset.customInformation_component_title',
                    )}
                    rightPart={
                      <CountWords
                        count={(title || '').length}
                        allCount={firstMaxLength}
                      />
                    }>
                    <Input
                      error={titleErr}
                      help={getI18n(
                        'allProducts.addproductset.thisitemcannotbeemptyorduplicated',
                      )}
                      autoFocus
                      size='large'
                      value={title}
                      onChange={onTitleChange}
                      maxLength={firstMaxLength}
                      disabled={disabled}
                    />
                  </ItemWrapper>
                </TopContainer>
              </React.Fragment>
            ),
          },
        ]}
      />
      <Row
        elements={[
          {
            child: (
              <React.Fragment>
                <TopContainer>
                  <ItemWrapper
                    title={getI18n('allProducts.addproductset.code')}
                    rightPart={
                      <CountWords
                        count={(code || '').length}
                        allCount={secondMaxLength}
                      />
                    }>
                    <Input
                      disabled={disabled}
                      error={codeErr}
                      size='large'
                      value={code}
                      onChange={onCodeChange}
                      maxLength={secondMaxLength}
                    />
                  </ItemWrapper>
                </TopContainer>
                <ModalFooter onCancel={onCancel} onOk={onOk} />
              </React.Fragment>
            ),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default AddCode;
